import { lastNDaysRange } from '@/shared/lib/dateRange';
import { typography, shadow, radius } from '@/shared/theme/tokens';
import { SearchInput } from '@/shared/ui/SearchInput';

export const HIST_DATE_RANGES = [
  { key: '1d',  label: '1D',  days: 1  },
  { key: '7d',  label: '7D',  days: 7  },
  { key: '14d', label: '14D', days: 14 },
  { key: '30d', label: '30D', days: 30 },
];

export function histDateParams(rangeKey) {
  const r = HIST_DATE_RANGES.find((x) => x.key === rangeKey) ?? HIST_DATE_RANGES[1];
  return lastNDaysRange(r.days);
}

export function HistoricalFilterBar({
  dateRange, onDateRange, c, isDark,
  search, onSearch, onOpenFilters, activeFilterCount = 0,
}) {
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'nowrap', width: '100%', minWidth: 0 }}>
      {/* date pills (unchanged) */}
      <div style={{ display: 'inline-flex', flexShrink: 0, borderRadius: radius.lg, border: `1px solid ${c.border}`, background: isDark ? 'rgba(255,255,255,0.04)' : c.bgSubtle, padding: '3px', gap: '2px' }}>
        {HIST_DATE_RANGES.map((r) => {
          const active = dateRange === r.key;
          return (
            <button key={r.key} onClick={() => onDateRange(r.key)} style={{
              padding: '6px 14px', borderRadius: radius.md, border: 'none', cursor: 'pointer',
              fontSize: typography.fontSize.md, fontWeight: active ? 600 : 500,
              fontFamily: typography.fontFamily.body,
              background: active ? (isDark ? 'rgba(255,255,255,0.1)' : '#fff') : 'transparent',
              color: active ? c.textActive : c.textSubtle,
              boxShadow: active ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
              transition: 'all 0.15s',
            }}>
              {r.label}
            </button>
          );
        })}
      </div>

      {/* free-text search */}
      {onSearch && (
        <SearchInput
          value={search}
          onChange={onSearch}
          placeholder="Search…"
          containerStyle={{ flex: '0 1 240px', minWidth: 180 }}
        />
      )}

      {/* filter button — solid primary, leading icon, active-count badge */}
      {onOpenFilters && (
        <button
          onClick={onOpenFilters}
          aria-label="open filters"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, flexShrink: 0,
            padding: '8px 16px', borderRadius: radius.md, cursor: 'pointer',
            fontSize: typography.fontSize.md, fontWeight: typography.fontWeight.semibold, fontFamily: typography.fontFamily.body,
            border: 'none',
            background: c.textActive, color: '#fff',
            boxShadow: shadow.btnSm,
            transition: 'filter 0.12s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.filter = 'brightness(0.94)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.filter = 'none'; }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 18 }}>tune</span>
          Filter
          {activeFilterCount > 0 && (
            <span style={{
              minWidth: 18, height: 18, borderRadius: radius.full, background: '#fff', color: c.textActive,
              fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.bold, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 5px',
            }}>
              {activeFilterCount}
            </span>
          )}
        </button>
      )}
    </div>
  );
}
